import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import ScreenLoader from '../../components/common/ScreenLoader';
import SearchField from '../../components/common/Search';
import Table from '../../components/common/Table';
import DeletePermissionsModal from '../../components/common/modals/delete';
import { studentsTableHeader } from '../../constants/appConstants';
import { setStudents } from '../../redux/slice/appSlice';
import { AuthenticatedGETRequest } from '../../utils';

const Students = ({ createNotification }) => {
    const { students } = useSelector((state) => state.appReducer);
    const dispatch = useDispatch();
    const [loading, setLoading] = useState(false);
    const [searchedRows, setSearchedRows] = useState(null);
    const [deleteId, setDeleteId] = useState(null);
    const [deleteModal, setDeleteModal] = useState(false);
    console.log(students);

    useEffect(() => {
        setLoading(true);
        const fetchData = async () => {
            try {
                const { data } = await AuthenticatedGETRequest('students');
                setLoading(false);
                dispatch(setStudents(data));
                setSearchedRows(data);
            } catch (error) {
                createNotification('error-toast', 'براہ کرم دوبارہ کوشش کریں۔');
                setLoading(false);
            }
        };
        fetchData();
        // eslint-disable-next-line
    }, [createNotification]);

    return loading ? (
        <ScreenLoader />
    ) : (
        <div className='flex column justifyCenter alignCenter w-100 content_area'>
            <div className='flex justifyCenter alignCenter w-100'>
                <h2>
                    طلبہ کی مجموعی تعداد :
                    <span
                        style={{
                            fontFamily: 'CircularStd',
                            fontSize: 26,
                            marginRight: 8,
                            color: '#2196f3',
                        }}
                    >
                        {searchedRows ? searchedRows.length : 0}
                    </span>
                </h2>
            </div>

            <SearchField
                label={`رجسڑریشن نمبر یا شناختی کارڈ اور موبائل نمبر سے تلاش کریں `}
                data={searchedRows}
                list={students}
                setSearchedRows={setSearchedRows}
            />
            {searchedRows && searchedRows.length > 0 ? (
                <Table
                    tableHeaders={studentsTableHeader}
                    data={searchedRows}
                    screen='students'
                    link={'dashboard/students/detail'}
                    openDelete={(id) => {
                        setDeleteModal(true);
                        setDeleteId(id);
                    }}
                    centeredIndex={7}
                />
            ) : (
                <div className='flex justifyCenter alignCenter w-100'>
                    <h1 style={{ marginTop: 56, color: '#e91e63', fontWeight: 900 }}>
                        {searchedRows && searchedRows.length > 0
                            ? 'معذرت، اس طالب علم کا کوئی ڈیٹا موجود نہیں ہے۔'
                            : 'طلبہ کا ریکارڈ موجود نہیں ہے۔'}
                    </h1>
                </div>
            )}

            <DeletePermissionsModal
                label='طالب علم کا ریکارڈ حذف کریں'
                description='کیا آپ اس طالب علم کے ریکارڈ کو مستقل طور پر حذف کرنے کا یقین رکھتے ہیں؟'
                btnText='حذف کریں'
                open={deleteModal}
                id={deleteId}
                screen='students'
                onError={(error) => createNotification('error-toast', error)}
                onClose={() => setDeleteModal(false)}
            />
        </div>
    );
};

export default Students;
